import HBMessage from "@/components/HBMessage";
import { useControllableValue, useMemoizedFn } from "ahooks";
import { useCallback } from "react";

export function useMultiSelect(
  options: {
    defaultValue?: any[];
    compareKey?: string;
    value?: any[];
    onChange?: (value: any) => void;
    maxCount?: number;
    /** 最大选择数量提示 */
    maxMessage?: string;
  } = {}
) {
  const { compareKey, maxCount, maxMessage } = options;
  const [value = [], setValue] = useControllableValue(options);

  // 判断是否已选中的辅助函数
  const isSelected = useCallback(
    (item) => {
      if (compareKey) {
        // 如果指定了比较键，则根据该键的值进行比较
        return value.some(
          (selectedItem) => selectedItem[compareKey] === item[compareKey]
        );
      } else {
        // 否则直接比较整个值
        return value.includes(item);
      }
    },
    [value, compareKey]
  );

  const onToggleSelect = useMemoizedFn((item) => {
    if (compareKey) {
      // 对象比较模式
      const isCurrentlySelected = value.some(
        (selectedItem) => selectedItem[compareKey] === item[compareKey]
      );

      if (isCurrentlySelected) {
        // 如果已选中，则从数组中移除
        setValue(
          value.filter(
            (selectedItem) => selectedItem[compareKey] !== item[compareKey]
          )
        );
      } else {
        if (maxCount && value.length >= maxCount) {
          HBMessage.error(maxMessage || `最多选择${maxCount}个`);
          return;
        }
        // 如果未选中，则添加到数组中
        setValue([...value, item]);
      }
    } else {
      // 普通值比较模式
      const isCurrentlySelected = value.includes(item);

      if (isCurrentlySelected) {
        setValue(value.filter((selectedItem) => selectedItem !== item));
      } else {
        if (maxCount && value.length >= maxCount) {
          HBMessage.error(maxMessage || `最多选择${maxCount}个`);
          return;
        }
        setValue([...value, item]);
      }
    }
  });

  return {
    value,
    onToggleSelect,
    setValue,
    isSelected,
  };
}
